<ng-container *ngIf="!(userNotFound | async); else userNotFoundTemplate">{{displayName | async}}</ng-container>
<ng-template #userNotFoundTemplate
  ><ng-container i18n="UserName.Notes@@unavailable">unavailable</ng-container></ng-template
>
